module.exports = __webpack_public_path__ + "img/bm-team-search.0c35f5e2.jpg";